import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';
import { MaintenanceService } from '../services/maintenance.service';
import { STATUS_CODES } from '../constants';
import type { MaintenanceInfoDto } from '@api/models';

export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const maintenanceService = inject(MaintenanceService);

  return next(req).pipe(
    tap({
      error: res => {
        if (
          res instanceof HttpErrorResponse
          && res.status === STATUS_CODES.maintenance
          && (res.error as MaintenanceInfoDto)?.isMaintenanceInProgress
        ) {
          maintenanceService.setMaintenanceInfo(res.error);
        }
      },
    })
  );
};
